import styled from "styled-components";

const SectionTitle = styled.h2`
  color: white;
  text-decoration: underline;
  font-size: 2rem;
  font-weight: 300;
  letter-spacing: 1px;
  margin-bottom: 2rem;
  z-index: 1;
`;

export default SectionTitle;
